// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#ffb71b' },
    secondary: { main: '#ff9e00' },
    background: { default: '#fff', paper: '#fff' },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
// I removed <React.StrictMode> (which was the overall parent below)

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* BrowserRouter wraps the entire app */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
